import { render, staticRenderFns } from "./selectRecognitionType.vue?vue&type=template&id=17c08d8c&scoped=true"
import script from "./selectRecognitionType.vue?vue&type=script&lang=js"
export * from "./selectRecognitionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c08d8c",
  null
  
)

export default component.exports